export default __webpack_public_path__ + "static/media/pencemaranSuara.fcd48333.jpg";